import DialogCodeConfirm from './DialogCodeConfirm'

export default DialogCodeConfirm 